import React from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import AdminHeader from "../admin/AdminHeader";
import AdminSidebar from "../admin/AdminSidebar";
import { Outlet } from "react-router-dom";

import {
  DRAWER_WIDTH,
  DRAWER_WIDTH_COLLAPSED,
  SIDEBAR_TRANSITION_MS,
  // ADMIN_HEADER_HEIGHT_PX,
  createDashboardTheme,
} from "../../theme/dashboardShell";

const theme = createDashboardTheme();

const STORAGE_KEY = "adminSidebarCollapsed";

const Dashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const toggleSidebar = React.useCallback(() => {
    setSidebarCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const drawerWidth = sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AdminSidebar collapsed={sidebarCollapsed} onToggleCollapse={toggleSidebar} />
      <Box
        sx={{
          ml: `${drawerWidth}px`,
          width: `calc(100% - ${drawerWidth}px)`,
          minHeight: "100dvh",
          bgcolor: "background.default",
          transition: (t) =>
            t.transitions.create(["margin", "width"], {
              easing: t.transitions.easing.sharp,
              duration: SIDEBAR_TRANSITION_MS,
            }),
        }}
      >
        <AdminHeader />

        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Dashboard;
